import { useEffect, useState } from "react";

// UPDATE 1: Add firestoreService prop to OnboardingModal
const OnboardingModal = ({ 
  isOpen = true, 
  onComplete, 
  availableTools = [], 
  onToolsSelected,
  firestoreService  // ✅ ADD THIS
}) => {
  const [introStep, setIntroStep] = useState(-1);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedTools, setSelectedTools] = useState([]);
  const [referralSource, setReferralSource] = useState([]);
  const [otherSource, setOtherSource] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadedImages, setLoadedImages] = useState([]);
  const [typedText, setTypedText] = useState('');
  const [contentFadingOut, setContentFadingOut] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [modalFadingOut, setModalFadingOut] = useState(false);
  const [showTypingAnimation, setShowTypingAnimation] = useState(false);
  const [userName, setUserName] = useState('');
  const [isSavingName, setIsSavingName] = useState(false); // ✅ ADD THIS

  // Intro texts
  const introTexts = [
    "Meet Preptune",
    { text: "A fluid assistant built ", highlight: "for you" }
  ];

const finalText = userName ? `Preptune is ready to chat and catch up with you, ${userName}` : "Preptune is ready to chat and catch up with you";
  // Tools configuration
  const defaultTools = [
    { 
      id: 'journal', 
      name: 'Journal', 
      description: 'Track your daily thoughts and mood',
      svg: (
        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.83892 12.4543s1.24988-3.08822-.21626-5.29004C8.15656 4.96245 4.58671 4.10885 4.39794 4.2436c-.18877.13476-1.11807 3.32546.34803 5.52727 1.4661 2.20183 5.09295 2.68343 5.09295 2.68343Zm0 0C10.3389 13.4543 12 15 12 18v2c0-2-.4304-3.4188 2.0696-5.9188m0 0s-.4894-2.7888 1.1206-4.35788c1.6101-1.56907 4.4903-1.54682 4.6701-1.28428.1798.26254.4317 2.84376-1.0809 4.31786-1.61 1.5691-4.7098 1.3243-4.7098 1.3243Z"/>
        </svg>
      ),
      bgColor: '#0bf58c37',
      borderColor: '#0bf58c5e'
    },
    { 
      id: 'podcast', 
      name: 'Podcast', 
      description: 'Get personalized audio briefings',
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>
        </svg>
      ),
      bgColor: '#8ea8ff36',
      borderColor: '#8ea8ff60'
    },
    { 
      id: 'planner', 
      name: 'Planner', 
      description: 'Organize your schedule effortlessly',
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
          <line x1="16" x2="16" y1="2" y2="6"/>
          <line x1="8" x2="8" y1="2" y2="6"/>
          <line x1="3" x2="21" y1="10" y2="10"/>
        </svg>
      ),
      bgColor: '#95d8ff5e',
      borderColor: '#95d8ff8f'
    },
    { 
      id: 'study', 
      name: 'Study', 
      description: 'Create flashcards and get instant help',
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>
      ),
      bgColor: '#ffded8bd',
      borderColor: '#ffded8de'
    }
  ];

  const tools = availableTools.length > 0 ? availableTools : defaultTools;

  // Image cards
  const imageCards = [
    {
      image: "/image/intro4.png",
      bgGradient: "linear-gradient(135deg, rgba(16, 185, 129, 0) 0%, rgba(5, 150, 104, 0.04)100%)",
      rotation: -12
    },
    {
      image: "/image/intro7.png",
      bgGradient: "linear-gradient(135deg, rgba(251, 191, 36, 0.3) 0%, rgba(245, 158, 11, 0.3) 100%)",
      rotation: -6
    },
    {
      image: "/image/intro3.png",
      bgGradient: "linear-gradient(135deg, rgba(59, 131, 246, 0.03) 0%, rgba(37, 100, 235, 0.05) 100%)",
      rotation: 0
    },
    {
      image: "/image/intro2.png",
      bgGradient: "linear-gradient(135deg, rgba(249, 115, 22, 0.3) 0%, rgba(234, 88, 12, 0.3) 100%)",
      rotation: 6
    },
    {
      image: "/image/intro6.png",
      bgGradient: "linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%,rgba(22, 163, 74, 0.03)) 100%)",
      rotation: 12
    }
  ];

  const referralOptions = [
    { id: 'instagram', label: 'Instagram', icon: 'https://img.freepik.com/premium-psd/instagram-logo_971166-164497.jpg?semt=ais_hybrid&w=740&q=80' },
    { id: 'tiktok', label: 'TikTok', icon: 'https://img.freepik.com/premium-vector/tiktok-app-icon-social-media-logo_277909-647.jpg?semt=ais_hybrid&w=740&q=80' },
    { id: 'youtube', label: 'YouTube', icon: 'https://www.transparentpng.com/download/youtube/orange-youtube-icon-png-7.png' },
    { id: 'linkedin', label: 'LinkedIn', icon: 'https://static.licdn.com/aero-v1/sc/h/al2o9zrvru7aqj8e1x2rzsrca' },
    { id: 'other', label: 'Other', icon: <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path></svg> }
  ];

  // Initial delay before starting intro
  useEffect(() => {
    if (introStep === -1 && !isAnimating) {
      const timer = setTimeout(() => {
        setIntroStep(0);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [introStep, isAnimating]);

  // Image loading animation
  useEffect(() => {
    if (currentStep === 0 && introStep === 2) {
      const indices = [0, 1, 2, 3, 4].sort(() => Math.random() - 0.5);
      indices.forEach((index, i) => {
        setTimeout(() => {
          setLoadedImages(prev => [...prev, index]);
        }, i * 150);
      });
    }
  }, [currentStep, introStep]);

  // Intro typing animation
  useEffect(() => {
    if (introStep >= 0 && introStep < 2 && !isAnimating) {
      setIsAnimating(true);
      const currentTextObj = introTexts[introStep];
      const isObject = typeof currentTextObj === 'object';
      const fullIntroText = isObject ? currentTextObj.text + currentTextObj.highlight : currentTextObj;
      let charIndex = 0;
      setTypedText('');
      
      const typingInterval = setInterval(() => {
        if (charIndex <= fullIntroText.length) {
          setTypedText(fullIntroText.substring(0, charIndex));
          charIndex++;
        } else {
          clearInterval(typingInterval);
          setTimeout(() => {
            setContentFadingOut(true);
            setTimeout(() => {
              setContentFadingOut(false);
              setIsAnimating(false);
              if (introStep < 1) {
                setIntroStep(prev => prev + 1);
              } else {
                setIntroStep(2);
              }
            }, 400);
          }, 800);
        }
      }, 40);
      
      return () => {
        clearInterval(typingInterval);
        setIsAnimating(false);
      };
    }
  }, [introStep]);

  // Username sync to Firestore ✅ ADD THIS
  useEffect(() => {
    const syncUserName = async () => {
      if (currentStep === 2 && userName.trim() && firestoreService?.isReady?.()) {
        try {
          setIsSavingName(true);
          await firestoreService.updateUserData({
            'settings.userName': userName.trim()
          });
          console.log('✅ Username synced to Firestore:', userName);
          setIsSavingName(false);
        } catch (error) {
          console.error('❌ Failed to sync username:', error);
          setIsSavingName(false);
        }
      }
    };

    const debounceTimer = setTimeout(() => {
      syncUserName();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [userName, currentStep, firestoreService]);

  // Final typing animation
  useEffect(() => {
    if (showTypingAnimation && !isAnimating) {
      setIsAnimating(true);
      let charIndex = 0;
      setTypedText('');
      
      const typingInterval = setInterval(() => {
        if (charIndex <= finalText.length) {
          setTypedText(finalText.substring(0, charIndex));
          charIndex++;
        } else {
          clearInterval(typingInterval);
          setTimeout(() => {
            setModalFadingOut(true);
            setTimeout(() => {
              setIsAnimating(false);
              if (onComplete) {
                const finalReferralSource = referralSource
                  .map(src => src === 'other' ? (otherSource.trim() || 'N/A') : src)
                  .join(', ');
                
                const toolsToSubmit = selectedTools.length > 0 ? selectedTools : tools.map(t => t.id);
                
                onComplete(toolsToSubmit, finalReferralSource, userName); // ✅ UPDATED
              }
            }, 600);
          }, 800);
        }
      }, 40);
      
      return () => {
        clearInterval(typingInterval);
        setIsAnimating(false);
      };
    }
  }, [showTypingAnimation]);

  const toggleTool = (toolId) => {
    setSelectedTools(prev => 
      prev.includes(toolId) 
        ? prev.filter(id => id !== toolId)
        : [...prev, toolId]
    );
  };

  const toggleReferral = (sourceId) => {
    setReferralSource(prev => {
      if (prev.includes(sourceId)) {
        if (sourceId === 'other') {
          setOtherSource('');
        }
        return prev.filter(id => id !== sourceId);
      } else {
        return [...prev, sourceId];
      }
    });
  };
useEffect(() => {
  if (showTypingAnimation && !isAnimating) {
    setIsAnimating(true);
    let charIndex = 0;
    setTypedText('');
    
    const typingInterval = setInterval(() => {
      if (charIndex <= finalText.length) {
        setTypedText(finalText.substring(0, charIndex));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setModalFadingOut(true);
          setTimeout(() => {
            setIsAnimating(false);
            if (onComplete) {
              // Make sure selectedTools is not empty
              const toolsToSubmit = selectedTools.length > 0 
                ? selectedTools 
                : tools.map(t => t.id);

              const finalReferralSource = referralSource
                .map(src => src === 'other' ? (otherSource.trim() || 'N/A') : src)
                .join(', ');

              console.log('✅ SUBMITTING TO HANDLEONBOARDINGCOMPLETE:', {
                tools: toolsToSubmit,
                referralSource: finalReferralSource,
                userName: userName
              });

              onComplete(toolsToSubmit, finalReferralSource, userName);
            }
          }, 600);
        }, 800);
      }
    }, 40);
    
    return () => {
      clearInterval(typingInterval);
      setIsAnimating(false);
    };
  }
}, [showTypingAnimation]);

const canContinue = () => {
  if (currentStep === 0) return true;
  if (currentStep === 1) return selectedTools.length > 0; // ✅ MUST have tools
  if (currentStep === 2) return userName.trim() !== '';
  if (currentStep === 3) {
    if (referralSource.length === 0) return false;
    if (referralSource.includes('other') && otherSource.trim() === '') return false;
    return true;
  }
  return false;
};

const handleContinue = () => {
  if (!canContinue() || isAnimating) return;

  if (currentStep === 3) {
    // Validate we have tools selected
    if (selectedTools.length === 0) {
      console.warn('⚠️ No tools selected');
      return;
    }

    console.log('🎯 Final submit with tools:', selectedTools);

    setContentFadingOut(true);
    setTimeout(() => {
      setContentFadingOut(false);
      setShowTypingAnimation(true);
    }, 400);
  } else {
    setCurrentStep(prev => prev + 1);
  }
};

// ✅ ALSO UPDATE THE FINAL TYPING ANIMATION COMPLETION to pass tools correctly:

useEffect(() => {
  if (showTypingAnimation && !isAnimating) {
    setIsAnimating(true);
    let charIndex = 0;
    setTypedText('');
    
    const typingInterval = setInterval(() => {
      if (charIndex <= finalText.length) {
        setTypedText(finalText.substring(0, charIndex));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setModalFadingOut(true);
          setTimeout(() => {
            setIsAnimating(false);
            if (onComplete) {
              // Make sure selectedTools is not empty
              const toolsToSubmit = selectedTools.length > 0 
                ? selectedTools 
                : tools.map(t => t.id);

              const finalReferralSource = referralSource
                .map(src => src === 'other' ? (otherSource.trim() || 'N/A') : src)
                .join(', ');

              console.log('✅ SUBMITTING TO HANDLEONBOARDINGCOMPLETE:', {
                tools: toolsToSubmit,
                referralSource: finalReferralSource,
                userName: userName
              });

              onComplete(toolsToSubmit, finalReferralSource, userName);
            }
          }, 600);
        }, 800);
      }
    }, 40);
    
    return () => {
      clearInterval(typingInterval);
      setIsAnimating(false);
    };
  }
}, [showTypingAnimation]);


  if (!isOpen) return null;

  return (
    <>
      <div className={`preptune-overlay ${modalFadingOut ? 'preptune-overlay-fade-out' : ''}`}>
        <div className="preptune-modal">
          {/* Intro Animations */}
          {introStep >= 0 && introStep < 2 && (
            <div className={`preptune-typing-container ${contentFadingOut ? 'preptune-content-fade-out' : ''}`}>
              <div className="preptune-typing-text preptune-intro-text">
                {(() => {
                  const currentTextObj = introTexts[introStep];
                  const isObject = typeof currentTextObj === 'object';
                  
                  if (!isObject) {
                    return (
                      <>
                        {typedText.split(' ').map((word, i) => (
                          <span key={i} className="preptune-word">
                            {word}{i < typedText.split(' ').length - 1 ? ' ' : ''}
                          </span>
                        ))}
                        <span className="preptune-typing-cursor">|</span>
                      </>
                    );
                  }
                  
                  const baseText = currentTextObj.text;
                  const highlightText = currentTextObj.highlight;
                  
                  if (typedText.length <= baseText.length) {
                    return (
                      <>
                        {typedText.split(' ').map((word, i) => (
                          <span key={i} className="preptune-word">
                            {word}{i < typedText.split(' ').length - 1 ? ' ' : ''}
                          </span>
                        ))}
                        <span className="preptune-typing-cursor">|</span>
                      </>
                    );
                  }
                  
                  const highlightPart = typedText.substring(baseText.length);
                  return (
                    <>
                      {baseText.split(' ').map((word, i) => (
                        <span key={i} className="preptune-word">
                          {word}{i < baseText.split(' ').length - 1 ? ' ' : ''}
                        </span>
                      ))}
                      <br />
                      <span className="preptune-highlight-word preptune-word">
                        {highlightPart}
                      </span>
                      <span className="preptune-typing-cursor">|</span>
                    </>
                  );
                })()}
              </div>
            </div>
          )}

          {/* Main Content */}
          {introStep === 2 && !showTypingAnimation && (
            <div className={`preptune-content-wrapper ${contentFadingOut ? 'preptune-content-fade-out' : ''}`}>
              {/* Step 0: Welcome */}
              {currentStep === 0 && (
                <div className="preptune-step-container">
                  <div className="preptune-welcome-wrapper">
                    <h1 className="preptune-main-title">Step Into Personalized Intelligence</h1>
                    <p className="preptune-main-desc">
                      Crafted to adapt seamlessly to your routine, making everyday life simple.
                    </p>
                    <div className="preptune-image-carousel-container">
                      <div className="preptune-image-carousel">
                        {imageCards.map((card, idx) => {
                          const isLoaded = loadedImages.includes(idx);
                          return (
                            <div 
                              key={idx}
                              className={`preptune-image-card ${isLoaded ? 'preptune-image-loaded' : ''}`}
                              style={{
                                transform: isLoaded 
                                  ? `rotate(${card.rotation}deg) translateY(${Math.abs(card.rotation) * 1.5}px)`
                                  : `rotate(${card.rotation}deg) translateY(${Math.abs(card.rotation) * 1.5}px) scale(0.9)`
                              }}
                            >
                              <div className="preptune-card-glass">
                                <img 
                                  src={card.image} 
                                  alt=""
                                  className="preptune-card-image"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                                <div 
                                  className="preptune-card-overlay"
                                  style={{ background: card.bgGradient }}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="preptune-feature-cards-container">
                      <h3 className="preptune-features-title">Get Started</h3>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 1: Tool Selection */}
              {currentStep === 1 && (
                <div className="preptune-step-container">
                  <h2 className="preptune-section-title">Personalize Your Experience</h2>
                  <p className="preptune-section-desc">Select the tools you'd like to use</p>
                  
                  <div className="preptune-tools-grid">
                    {tools.map(tool => {
                      const isSelected = selectedTools.includes(tool.id);
                      
                      return (
                        <div
                          key={tool.id}
                          className={`preptune-tool-item ${isSelected ? 'preptune-tool-selected' : ''}`}
                          onClick={() => toggleTool(tool.id)}
                          style={{ position: 'relative' }}
                        >
                          <div 
                            className="preptune-tool-icon-circle" 
                            style={{
                              background: tool.bgColor,
                              border: `1px solid ${tool.borderColor}`
                            }}
                          >
                            <div style={{ color: 'black' }}>
                              {tool.svg}
                            </div>
                          </div>
                          <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '3px', 
                            textAlign: 'left', 
                            flex: 1 
                          }}>
                            <span style={{ 
                              fontSize: '13px', 
                              fontWeight: 500, 
                              color: '#374151',
                              display: 'block'
                            }}>
                              {tool.name}
                            </span>
                            <span style={{ 
                              fontSize: '11px', 
                              color: '#6b7280', 
                              lineHeight: '1.4',
                              display: 'block'
                            }}>
                              {tool.description}
                            </span>
                          </div>
                          {isSelected && (
                            <div className="preptune-check-badge">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Step 2: Name Input ✅ UPDATED */}
{currentStep === 2 && (
  <div className="preptune-step-container">
    <h2 className="preptune-section-title">What's your name?</h2>
    <p className="preptune-section-desc">This helps Preptune personalize your experience</p>
    
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', paddingTop: '20px' }}>
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter first name"
          className="preptune-name-field-updated"
          autoFocus
          onKeyPress={(e) => e.key === 'Enter' && canContinue() && handleContinue()}
        />
        {isSavingName && (
          <span style={{
            position: 'absolute',
            right: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '12px',
            color: '#9ca3af'
          }}>
          </span>
        )}
      </div>
    </div>
  </div>
)}

              {/* Step 3: Referral Source ✅ UPDATED */}
              {currentStep === 3 && (
                <div className="preptune-step-container">
                  <h2 className="preptune-section-title">How did you hear about us?</h2>
                  <p className="preptune-section-desc">Select all that apply</p>
                  
                  <div className="preptune-referral-grid">
                    {referralOptions.map(option => (
                      <div
                        key={option.id}
                        className={`preptune-referral-item ${referralSource.includes(option.id) ? 'preptune-referral-selected' : ''}`}
                        onClick={() => toggleReferral(option.id)}
                        style={{ position: 'relative' }}
                      >
                        <div className="preptune-referral-icon-box">
                          {typeof option.icon === 'string' ? (
                            <img src={option.icon} alt={option.label} style={{ width: '22px', height: '22px' }} />
                          ) : (
                            option.icon
                          )}
                        </div>
                        <span className="preptune-referral-name">{option.label}</span>
                        {referralSource.includes(option.id) && (
                          <div className="preptune-check-badge-small">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {referralSource.includes('other') && (
                    <input
                      type="text"
                      value={otherSource}
                      onChange={(e) => setOtherSource(e.target.value)}
                      placeholder="Please specify or type N/A..."
                      className="preptune-other-field"
                      autoFocus
                    />
                  )}
                </div>
              )}

              {/* Navigation */}
              <div className="preptune-nav-section">
                {currentStep === 3 ? ( // ✅ UPDATED
                  <button 
                    className={`preptune-primary-action ${(referralSource.length === 0 || (referralSource.includes('other') && otherSource.trim() === '')) ? 'preptune-button-disabled' : ''}`}
                    onClick={handleContinue}
                    disabled={referralSource.length === 0 || (referralSource.includes('other') && otherSource.trim() === '')}
                  >
                    Finish
                  </button>
                ) : currentStep === 1 ? (
                  <button 
                    className={`preptune-primary-action ${selectedTools.length === 0 ? 'preptune-button-disabled' : ''}`}
                    onClick={handleContinue}
                    disabled={selectedTools.length === 0}
                  >
                    Continue
                  </button>
                ) : (
                  <button 
                    className={`preptune-primary-action ${currentStep === 2 && !userName.trim() ? 'preptune-button-disabled' : ''}`} // ✅ UPDATED
                    onClick={handleContinue}
                    disabled={currentStep === 2 && !userName.trim()} // ✅ UPDATED
                  >
                    Continue
                  </button>
                )}
              </div>

              {/* Progress */}
              <div className="preptune-progress-bar">
                {[0, 1, 2, 3].map(step => ( // ✅ UPDATED
                  <div
                    key={step}
                    className={`preptune-progress-item ${step === currentStep ? 'preptune-progress-active' : ''} ${step < currentStep ? 'preptune-progress-done' : ''}`}
                    onClick={() => step < currentStep && setCurrentStep(step)}
                    style={{ cursor: step <= currentStep ? 'pointer' : 'default' }}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Final Typing Animation */}
          {showTypingAnimation && (
            <div className="preptune-typing-container">
              <div className="preptune-typing-text">
                {typedText.split(' ').map((word, i) => (
                  <span key={i} className="preptune-word">
                    {word}{i < typedText.split(' ').length - 1 ? ' ' : ''}
                  </span>
                ))}
                <span className="preptune-typing-cursor">|</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .preptune-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          display: flex;
          align-items: flex-end;
          justify-content: center;
          z-index: 99999;
          animation: preptuneOverlayFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
.preptune-name-field-updated {
  width: 100%;
  padding: 14px 18px;
  border: 1.5px solid #4f4f4fff;
  border-radius: 28px;
  font-size: 16px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: all 0.2s;
  outline: none;
  font-family: inherit;
  text-align: left;
  letter-spacing: 0.3px;
  color: #1f2937;
}

.preptune-name-field-updated::placeholder {
  color: #9ca3af;
  text-align: left;
}

.preptune-name-field-updated:focus {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  background: #fafafa;
  border-color: #000000;
}
        .preptune-overlay.preptune-overlay-fade-out {
          opacity: 0;
          pointer-events: none;
        }

        .preptune-modal {
          position: relative;
          width: 100%;
          max-width: 420px;
          height: 95vh;
          background: linear-gradient(170deg, #fefefeff 0%, #fefefeff 60%, #e0e7fcff 100%);
          border-radius: 30px 30px 0 0;
          padding: 16px 16px 40px;
          box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.2);
          animation: preptuneModalSlideUp 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .preptune-content-wrapper {
          display: flex;
          flex-direction: column;
          height: 100%;
          opacity: 1;
          animation: preptuneFadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), filter 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          filter: blur(0px);
          transform: scale(1);
        }

        .preptune-content-wrapper.preptune-content-fade-out {
          opacity: 0;
          filter: blur(8px);
          transform: scale(0.98);
          pointer-events: none;
        }

        .preptune-typing-container {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 32px;
          opacity: 1;
          animation: preptuneTypingFadeIn 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), filter 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          filter: blur(0px);
          transform: scale(1);
        }

        .preptune-typing-container.preptune-content-fade-out {
          opacity: 0;
          filter: blur(8px);
          transform: scale(0.98);
        }

        .preptune-typing-text {
          font-size: 28px;
          font-weight: 500;
          color: #1f2937;
          text-align: center;
          line-height: 1.5;
          max-width: 360px;
          word-wrap: break-word;
        }

        .preptune-intro-text {
          max-width: 320px;
        }

        .preptune-highlight-word {
          color: #3b82f6;
        }

        .preptune-word {
          display: inline;
          animation: preptuneWordAppear 0.4s ease-out;
        }

        .preptune-typing-cursor {
          display: inline-block;
          margin-left: 3px;
          animation: preptuneCursorBlink 0.8s infinite;
          font-weight: 300;
        }

        .preptune-step-container {
          display: flex;
          flex-direction: column;
          gap: 20px;
          flex: 1;
        }

        .preptune-welcome-wrapper {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
        }

        .preptune-main-title {
          font-size: 22px;
          font-weight: 400;
          color: #000000ff;
          margin: 30px 0 0 0;
        }

        .preptune-main-desc {
          font-size: 17px;
          color: #6b7280;
          line-height: 1.6;
          margin: 0;
          max-width: 80%;
        }

        .preptune-image-carousel-container {
          width: calc(100% + 32px);
          margin-left: -16px;
          margin-right: -16px;
          overflow: hidden;
          margin-top: 70px;
          padding: 0;
          position: relative;
          height: 160px;
        }

        .preptune-image-carousel {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          width: 150%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }

        .preptune-image-card {
          width: 82px;
          height: 110px;
          flex-shrink: 0;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          opacity: 0;
          filter: blur(10px);
        }

        .preptune-image-card.preptune-image-loaded {
          opacity: 1;
          filter: blur(0px);
        }

        .preptune-card-glass {
          width: 100%;
          height: 100%;
          border-radius: 18px;
          overflow: hidden;
          position: relative;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.16);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.28);
        }

        .preptune-card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .preptune-card-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          backdrop-filter: blur(0px);
          -webkit-backdrop-filter: blur(0px);
          mix-blend-mode: overlay;
          pointer-events: none;
        }

        .preptune-section-title {
          font-size: 26px;
          font-weight: 400;
          color: #000000ff;
          margin: 30px 0 0 0;
          text-align: center;
        }

        .preptune-section-desc {
          font-size: 16px;
          color: #6b7280;
          margin: 10px;
          text-align: center;
          line-height: 1.5;
        }

        .preptune-tools-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }

        .preptune-tool-item {
          background: white;
          border-radius: 28px;
          padding: 14px 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 2px 6.5px rgba(0, 0, 0, 0.18);
          min-height: 70px;
        }

        .preptune-tool-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        }

        .preptune-tool-item.preptune-tool-selected {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          background: #fafafa;
        }

        .preptune-tool-icon-circle {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.2s;
        }

        .preptune-check-badge {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 22px;
          height: 22px;
          background: #000000;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: preptuneCheckScaleIn 0.2s ease;
        }

        .preptune-name-field {
          width: 100%;
          padding: 16px 18px;
          border: none;
          border-radius: 28px;
          font-size: 16px;
          background: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transition: all 0.2s;
          outline: none;
          font-family: inherit;
          text-align: center;
          letter-spacing: 0.3px;
        }

        .preptune-name-field::placeholder {
          color: #9ca3af;
        }

        .preptune-name-field:focus {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          background: #fafafa;
        }

        .preptune-referral-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
        }

        .preptune-referral-item {
          background: white;
          border-radius: 28px;
          padding: 14px 16px;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 2px 7px rgba(0, 0, 0, 0.18);
          min-height: 56px;
        }

        .preptune-referral-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        }

        .preptune-referral-item.preptune-referral-selected {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          background: #fafafa;
        }

        .preptune-referral-icon-box {
          color: #1f2937;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .preptune-referral-name {
          font-size: 13px;
          font-weight: 500;
          color: #374151;
        }

        .preptune-other-field {
          width: 100%;
          padding: 14px 16px;
          border: none;
          border-radius: 28px;
          font-size: 14px;
          background: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transition: all 0.2s;
          outline: none;
          font-family: inherit;
        }

        .preptune-other-field:focus {
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }

        .preptune-nav-section {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: auto;
          padding-top: 16px;
        }

        .preptune-check-badge-small {
          position: absolute;
          top: 6px;
          right: 6px;
          width: 18px;
          height: 18px;
          background: #000000;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: preptuneCheckScaleIn 0.2s ease;
        }

        .preptune-primary-action {
          position: relative;
          bottom: 30px;
          width: 100%;
          padding: 14px;
          background: #000000;
          color: white;
          border: none;
          border-radius: 28px;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          font-family: inherit;
        }

        .preptune-primary-action.preptune-button-disabled {
          background: #d1d5db;
          color: #9ca3af;
          cursor: not-allowed;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        .preptune-primary-action:not(.preptune-button-disabled):hover {
          background: #1a1a1a;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .preptune-skip-action {
          width: 100%;
          padding: 10px;
          background: transparent;
          color: #6b7280;
          border: none;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          font-family: inherit;
        }

        .preptune-skip-action:hover {
          color: #1f2937;
        }

        .preptune-progress-bar {
          display: flex;
          justify-content: center;
          gap: 6px;
          margin-top: 12px;
        }

        .preptune-progress-item {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.15);
          transition: all 0.3s;
        }

        .preptune-progress-item.preptune-progress-active {
          width: 20px;
          border-radius: 3px;
          background: #000000;
        }

        .preptune-progress-item.preptune-progress-done {
          background: rgba(0, 0, 0, 0.15);
        }

        .preptune-feature-cards-container {
          width: 100%;
          padding: 14px 16px 0;
          margin: 0 -16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-radius: 0;
        }

        .preptune-features-title {
          font-size: 16px;
          font-weight: 500;
          color: #000000ff;
          margin: 0 0 24px 0;
          text-align: center;
          letter-spacing: 0.3px;
        }

        @keyframes preptuneOverlayFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes preptuneModalSlideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes preptuneFadeIn {
          from {
            opacity: 0;
            transform: scale(0.98);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes preptuneTypingFadeIn {
          from {
            opacity: 0;
            filter: blur(8px);
            transform: scale(0.96);
          }
          to {
            opacity: 1;
            filter: blur(0px);
            transform: scale(1);
          }
        }

        @keyframes preptuneWordAppear {
          from {
            opacity: 0;
            filter: blur(4px);
          }
          to {
            opacity: 1;
            filter: blur(0px);
          }
        }

        @keyframes preptuneCursorBlink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0; }
        }

        @keyframes preptuneCheckScaleIn {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }

        @media (max-width: 640px) {
          .preptune-modal {
            width: 100%;
            height: 85vh;
            border-radius: 24px 24px 0 0;
            padding: 14px 14px 35px;
          }

          .preptune-main-title {
            font-size: 26px;
          }

          .preptune-section-title {
            font-size: 27px;
          }

          .preptune-typing-text {
            font-size: 24px;
          }

          .preptune-typing-container {
            padding: 32px 20px;
          }

          .preptune-tools-grid {
            grid-template-columns: 1fr;
          }

          .preptune-tool-item {
            min-height: 60px;
          }

          .preptune-referral-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 380px) {
          .preptune-main-title {
            font-size: 30px;
          }

          .preptune-section-title {
            font-size: 16px;
          }

          .preptune-typing-text {
            font-size: 22px;
          }

          .preptune-typing-container {
            padding: 28px 16px;
          }
        }
      `}</style>
    </>
  );
};

export default OnboardingModal;